












































































































import { MainNavigationVueMK } from "@/extensions/navigation/MainNavigationVueMK";
import { Component } from "vue-property-decorator";
// import { MainNavigationVue } from "fs-pb-vue2/vueModels/navigation/MainNavigationVue";

@Component({
  components: {  }
})
export default class MobileNavigation extends MainNavigationVueMK {
  openLink(link: string): void {
    if (this.$route.path !== link)
      this.$router.push(link);
  }

  linkTexts: Array<string> = ['/', '/payments', '/cashback'];
}
